// 应用中心模块页面级国际化
export default {
  'pages.app.common.appId': '应用ID',
  'pages.app.common.appName': '应用名称',
  'pages.app.common.description': '描述',
  'pages.app.common.type': '类型',
  'pages.app.common.order': '排序',
  'pages.app.common.status': '状态',
  'pages.app.common.operation': '操作',
  'pages.app.common.company': '公司',
  'pages.app.common.department': '部门',
  'pages.app.common.role': '角色',
  'pages.app.common.user': '用户',
  'pages.app.common.createTime': '创建时间',
  'pages.app.common.updateTime': '更新时间',
  'pages.app.common.creator': '创建人',
  'pages.app.common.updater': '更新人',
  'pages.app.common.enabled': '启用',
  'pages.app.common.disabled': '禁用',
  'pages.app.common.enabledIn': '启用中',
  'pages.app.common.disabledIn': '停用',
  'pages.app.common.disabledDone': '已停用',
  'pages.app.common.noDescription': '暂无描述',
  'pages.app.common.notAvailable': 'N/A',
  'pages.app.common.other': '其他',
  'pages.app.common.all': '全部',
  'pages.app.common.chat': '聊天',
  'pages.app.common.search': '搜索',
  'pages.app.common.memory': '记忆',
  'pages.app.common.agent': '智能体',
  'pages.app.common.more': '更多',
  'pages.app.common.collapse': '收起',
  'pages.app.common.searchPlaceholder': '请输入',
  'pages.app.common.keywordPlaceholder': '请输入关键词',
  'pages.app.common.filterCondition': '筛选条件',
  'pages.app.common.icon': '图标',
  'pages.app.common.total': '总记录数',
  'pages.app.common.export': '导出',
  'pages.app.common.print': '打印',
  'pages.app.common.exportOptionExcel': 'Excel (.xlsx)',
  'pages.app.common.exportOptionCsv': 'CSV (.csv)',
  'pages.app.common.exportOptionPdf': 'PDF (.pdf)',
  'pages.app.mine.title': '我的应用',
  'pages.app.mine.unionQuery': '联合查询',
  'pages.app.mine.fetchListFailed': '获取应用列表失败',
  'pages.app.mine.noDescription': '暂无描述',
  'pages.app.mine.useUserCount': '{count} 人使用',
  'pages.app.exportOptionExcel': 'Excel (.xlsx)',
  'pages.app.exportOptionCsv': 'CSV (.csv)',
  'pages.app.exportOptionPdf': 'PDF (.pdf)',
  'pages.app.action.edit': '编辑',
  'pages.app.action.config': '配置',
  'pages.app.action.enable': '启用',
  'pages.app.action.disable': '停用',
  'pages.app.action.export': '导出',
  'pages.app.action.create': '新建',
  'pages.app.mgmt.list.title': '应用管理',
  'pages.app.mgmt.list.reportTitle': '应用列表',
  'pages.app.mgmt.list.reportDataTitle': '应用数据',
  'pages.app.mgmt.list.unionQuery': '联合查询',
  'pages.app.mgmt.list.appType': '应用类型',
  'pages.app.mgmt.list.appTypePlaceholder': '请选择或输入应用类型',
  'pages.app.mgmt.list.totalApps': '总应用数',
  'pages.app.mgmt.list.summary': '共 {count} 条数据',
  'pages.app.mgmt.list.exportNoData': '暂无数据可导出',
  'pages.app.mgmt.list.exportSuccess': '导出成功',
  'pages.app.mgmt.list.exportFailed': '导出失败',
  'pages.app.mgmt.list.toggleSuccess': '操作成功',
  'pages.app.mgmt.list.toggleFailed': '操作失败',
  'pages.app.mgmt.list.confirmTitle': '确认操作',
  'pages.app.mgmt.list.confirmDisable': '确定要停用这个应用吗？',
  'pages.app.mgmt.list.confirmEnable': '确定要启用这个应用吗？',
  'pages.app.detail.title': '应用详情',
  'pages.app.detail.edit': '编辑',
  'pages.app.detail.backList': '返回列表',
  'pages.app.detail.fetchFailed': '获取应用详情失败',
  'pages.app.detail.appIcon': '应用图标',
  'pages.app.detail.basicInfo': '基础信息',
  'pages.app.detail.accessControl': '访问控制',
  'pages.app.detail.description': '应用描述',
  'pages.app.detail.company': '所属公司',
  'pages.app.detail.department': '所属部门',
  'pages.app.detail.role': '所属角色',
  'pages.app.detail.user': '所属用户',
  'pages.app.create.title': '创建应用',
  'pages.app.edit.title': '编辑应用',
  'pages.app.form.appName.label': '应用名称',
  'pages.app.form.appName.placeholder': '请输入应用名称',
  'pages.app.form.appName.required': '请输入应用名称',
  'pages.app.form.appIcon.label': '应用图标',
  'pages.app.form.appType.label': '应用类型',
  'pages.app.form.appType.placeholder': '请选择类型',
  'pages.app.form.appType.required': '请选择类型',
  'pages.app.form.description.label': '应用描述',
  'pages.app.form.description.placeholder': '请输入应用描述',
  'pages.app.form.order.label': '排序',
  'pages.app.form.order.placeholder': '请输入排序号',
  'pages.app.form.order.required': '请输入排序号',
  'pages.app.form.status.label': '状态',
  'pages.app.form.status.placeholder': '请选择状态',
  'pages.app.form.status.required': '请选择状态',
  'pages.app.form.status.enabled': '启用',
  'pages.app.form.status.disabled': '禁用',
  'pages.app.form.company.label': '所属公司',
  'pages.app.form.company.placeholder': '请选择所属公司',
  'pages.app.form.department.label': '所属部门',
  'pages.app.form.department.placeholder': '请选择所属部门',
  'pages.app.form.role.label': '所属角色',
  'pages.app.form.role.placeholder': '请选择所属角色',
  'pages.app.form.user.label': '所属用户',
  'pages.app.form.user.placeholder': '请选择所属用户',
  'pages.app.form.keywordPlaceholder': '请输入关键词',
  'pages.app.create.method.label': '创建方式',
  'pages.app.create.method.required': '请选择创建方式',
  'pages.app.create.method.blank': '从空白创建',
  'pages.app.create.method.template': '从模板创建',
  'pages.app.create.method.import': '导入JSON文件',
  'pages.app.create.agentType.label': '智能体类型',
  'pages.app.create.agentType.required': '请选择智能体类型',
  'pages.app.create.agentType.flow': '智能体流程',
  'pages.app.create.agentType.pipeline': 'Ingestion pipeline',
  'pages.app.create.template.label': '选择模板',
  'pages.app.create.template.placeholder': '请选择模板',
  'pages.app.create.template.required': '请选择模板',
  'pages.app.create.dsl.label': 'DSL文件',
  'pages.app.create.dsl.selectFile': '选择JSON文件',
  'pages.app.create.dsl.selected': '已选择：{name}',
  'pages.app.create.dsl.empty': 'DSL 文件内容不能为空',
  'pages.app.create.dsl.invalidGraph': 'DSL 文件缺少有效的节点数据（graph.nodes）',
  'pages.app.create.dsl.invalidJson': '文件内容不是合法的 JSON 格式',
  'pages.app.create.error.selectTemplate': '请选择模板',
  'pages.app.create.error.templateNotFound': '未找到所选模板数据，请重新选择',
  'pages.app.create.error.selectDslFile': '请选择 DSL JSON 文件',
  'pages.app.create.error.selectCreateMethod': '请选择创建方式',
  'pages.app.create.error.appTypeInvalid': '应用类型错误',
  'pages.app.create.error.createFailed': '创建失败',
  'pages.app.create.error.createAgentFailed': '创建智能体失败',
  'pages.app.create.error.fetchGlobalConfigFailed': '获取用户全局配置失败',
  'pages.app.create.success': '创建成功',
  'pages.app.edit.error.fetchFailed': '获取应用详情失败',
  'pages.app.edit.error.updateFailed': '更新应用失败',
  'pages.app.edit.error.updateAgentFailed': '更新智能体失败',
  'pages.app.edit.success': '更新应用成功',
  'pages.app.analysis.company': '公司',
  'pages.app.analysis.date': '日期',
  'pages.app.analysis.appName': '应用名称',
  'pages.app.analysis.userCount': '使用人数',
  'pages.app.analysis.tokenUsed': 'Token 消耗',
  'pages.app.analysis.appCount': '应用数量',
  'pages.app.analysis.appFilterLabel': '应用',
  'pages.app.analysis.appFilterPlaceholder': '请选择应用',
  'pages.app.analysis.tab.usage': '使用人数',
  'pages.app.analysis.tab.token': 'Token 消耗量',
  'pages.app.analysis.tab.count': '应用数量',
  'pages.app.analysis.rank.app': '应用',
  'pages.app.analysis.rank.company': '公司',
  'pages.app.analysis.rank.user': '用户',
  'pages.app.analysis.quick.today': '今日',
  'pages.app.analysis.quick.week': '本周',
  'pages.app.analysis.quick.month': '本月',
  'pages.app.analysis.quick.year': '全年',
  'pages.app.analysis.query.hourly': '按小时',
  'pages.app.analysis.query.daily': '按天',
  'pages.app.analysis.query.weekly': '按周',
  'pages.app.analysis.query.monthly': '按月',
  'pages.app.analysis.chart.usageTrend': '应用使用人数趋势',
  'pages.app.analysis.chart.tokenTrend': '应用 Token 消耗趋势',
  'pages.app.analysis.chart.countTrend': '应用数量趋势',
  'pages.app.analysis.rank.usage': '使用人数排名',
  'pages.app.analysis.rank.token': 'Token 消耗排行',
  'pages.app.analysis.metric.usage': '使用人数',
  'pages.app.analysis.metric.token': 'Token 消耗量',
  'pages.app.analysis.metric.count': '应用数量',
  'pages.app.config.updateSuccess': '更新成功',
  'pages.app.config.updateFailed': '更新失败',
  'pages.app.config.deleteSuccess': '删除成功',
  'pages.app.config.deleteFailed': '删除失败',
  'pages.app.config.addSuccess': '添加成功',
  'pages.app.config.addFailed': '添加失败',
  'pages.app.config.saveSuccess': '设置已保存',
  'pages.app.config.saveFailed': '保存失败',
  'pages.app.config.defaultTitle': '设置默认模型',
  'pages.app.config.subtitle': '请在开始之前完成这些设置',
  'pages.app.config.selectModelPlaceholder': '请选择模型',
  'pages.app.config.addedModelsTitle': '已添加的模型',
  'pages.app.config.hideModels': '隐藏模型',
  'pages.app.config.showMoreModels': '展示更多模型',
  'pages.app.config.addModelHint': '添加模型（OpenAI、Gemini...）',
  'pages.app.config.addModel': '添加模型',
  'pages.app.config.providerLabel': '模型提供商',
  'pages.app.config.providerRequired': '请选择模型提供商',
  'pages.app.config.apiKeyRequired': '请输入 API Key',
  'pages.app.config.editTitle': '编辑 {name} 配置',
  'pages.app.searchConfig.name.label': '姓名',
  'pages.app.searchConfig.name.placeholder': '请输入姓名',
  'pages.app.searchConfig.name.required': '请输入姓名',
  'pages.app.searchConfig.avatar': '头像',
  'pages.app.searchConfig.upload': '上传',
  'pages.app.searchConfig.uploadTip': '你可以上传4MB的文件',
  'pages.app.searchConfig.description.label': '描述',
  'pages.app.searchConfig.description.placeholder': '请输入描述',
  'pages.app.searchConfig.knowledgeBase.label': '知识库',
  'pages.app.searchConfig.knowledgeBase.placeholder': '请选择',
  'pages.app.searchConfig.knowledgeBase.required': '请选择知识库',
  'pages.app.searchConfig.knowledgeBase.sample2': '示例知识库 2',
  'pages.app.searchConfig.metadata.label': '元数据',
  'pages.app.searchConfig.metadata.tooltip': '选择检索时参考的元数据',
  'pages.app.searchConfig.metadata.auto': '自动',
  'pages.app.searchConfig.similarityThreshold.label': '相似度阈值',
  'pages.app.searchConfig.similarityThreshold.tooltip': '检索文档片段的最小相似度评分',
  'pages.app.searchConfig.vectorWeight.label': '向量相似度权重',
  'pages.app.searchConfig.vectorWeight.tooltip': '控制向量检索和全文检索的权重占比',
  'pages.app.searchConfig.rerankModel': 'rerank 模型',
  'pages.app.searchConfig.aiSummary': 'AI 总结',
  'pages.app.searchConfig.enableRelatedSearch': '启用相关搜索',
  'pages.app.searchConfig.showMindMap': '显示查询思维导图',
  'pages.app.memoryConfig.memoryType.label': '记忆类型',
  'pages.app.memoryConfig.memoryType.tooltip': '选择记忆的类型',
  'pages.app.memoryConfig.memoryType.placeholder': '请选择',
  'pages.app.memoryConfig.memoryType.required': '请选择记忆类型',
  'pages.app.memoryConfig.memoryType.raw': '原始',
  'pages.app.memoryConfig.memoryType.semantic': '语义',
  'pages.app.memoryConfig.memoryType.episodic': '情景',
  'pages.app.memoryConfig.memoryType.procedural': '程序',
  'pages.app.memoryConfig.embeddingModel.label': '嵌入模型',
  'pages.app.memoryConfig.embeddingModel.tooltip': '选择用于文本向量化的模型',
  'pages.app.memoryConfig.embeddingModel.placeholder': '请选择',
  'pages.app.memoryConfig.embeddingModel.required': '请选择嵌入模型',
  'pages.app.memoryConfig.llm.label': '大语言模型',
  'pages.app.memoryConfig.llm.tooltip': '选择用于处理任务的语言模型',
  'pages.app.memoryConfig.llm.placeholder': '请选择',
  'pages.app.memoryConfig.llm.required': '请选择大语言模型',
  'pages.app.chatConfig.title': '聊天配置',
  'pages.app.chatConfig.avatar': '助理头像',
  'pages.app.chatConfig.upload': '上传',
  'pages.app.chatConfig.uploadTip': '你可以上传4MB的文件',
  'pages.app.chatConfig.uploadTooLarge': '文件必须小于 4MB!',
  'pages.app.chatConfig.emptyReply.label': '空回复',
  'pages.app.chatConfig.emptyReply.tooltip': '当系统无法回答时返回的内容',
  'pages.app.chatConfig.emptyReply.placeholder': '请输入空回复内容',
  'pages.app.chatConfig.prologue.label': '设置开场白',
  'pages.app.chatConfig.prologue.tooltip': '对话开始时的欢迎语',
  'pages.app.chatConfig.prologue.placeholder': '请输入开场白',
  'pages.app.chatConfig.showCitations': '显示引文',
  'pages.app.chatConfig.keywordAnalysis': '关键词分析',
  'pages.app.chatConfig.textToSpeech': '文本转语音',
  'pages.app.chatConfig.directoryEnhancement': '目录增强',
  'pages.app.chatConfig.showCitations.tooltip': '在回答中显示引用的文档来源',
  'pages.app.chatConfig.keywordAnalysis.tooltip': '对用户问题进行关键词提取和分析',
  'pages.app.chatConfig.textToSpeech.tooltip': '将回答内容转换为语音播放',
  'pages.app.chatConfig.directoryEnhancement.tooltip': '根据文档目录结构优化检索效果',
  'pages.app.chatConfig.knowledgeBase.label': '知识库',
  'pages.app.chatConfig.knowledgeBase.tooltip': '选择该助理关联的知识库',
  'pages.app.chatConfig.knowledgeBase.placeholder': '请选择',
  'pages.app.chatConfig.knowledgeBase.sample1': '示例知识库 1',
  'pages.app.chatConfig.knowledgeBase.sample2': '示例知识库 2',
  'pages.app.chatConfig.systemPrompt.label': '系统提示词',
  'pages.app.chatConfig.systemPrompt.placeholder': '请输入系统提示词',
  'pages.app.chatConfig.similarityThreshold.label': '相似度阈值',
  'pages.app.chatConfig.similarityThreshold.tooltip': '检索文档片段的最小相似度评分',
  'pages.app.chatConfig.vectorWeight.label': '向量相似度权重',
  'pages.app.chatConfig.vectorWeight.tooltip': '控制向量检索和全文检索的权重占比',
  'pages.app.chatConfig.multiRoundOptimization.label': '多轮对话优化',
  'pages.app.chatConfig.multiRoundOptimization.tooltip': '对于多轮对话的提问分析和历史总结，内容会用于参与上下文',
  'pages.app.chatConfig.useKnowledgeGraph.label': '使用知识图谱',
  'pages.app.chatConfig.useKnowledgeGraph.tooltip': '将知识库内容转换为知识图谱，参与问题分析与推理',
  'pages.app.chatConfig.reasoning.label': '推理',
  'pages.app.chatConfig.reasoning.tooltip': '利用知识图谱进行问答推理，增强准确性',
  'pages.app.chatConfig.rerankModel.label': 'Rerank模型',
  'pages.app.chatConfig.rerankModel.tooltip': '选择用于重排序的模型',
  'pages.app.chatConfig.crossLanguageSearch.label': '跨语言搜索',
  'pages.app.chatConfig.crossLanguageSearch.tooltip': '开启跨语言搜索功能',
  'pages.app.chatConfig.crossLanguageSearch.disabled': '禁用',
  'pages.app.chatConfig.crossLanguageSearch.enabled': '启用',
  'pages.app.chatConfig.selectPlaceholder': '请选择',
  'pages.app.chatConfig.topN.label': 'Top N',
  'pages.app.chatConfig.topN.tooltip': '每次检索返回的最相关的文档片段数量',
  'pages.app.chatConfig.variables.label': '变量',
  'pages.app.chatConfig.variables.tooltip': '提示词中可引用的动态变量',
  'pages.app.chatConfig.variables.delete': '删除',
  'pages.app.chatConfig.variables.keyword': '关键字',
  'pages.app.chatConfig.variables.keywordPlaceholder': '请输入关键字',
  'pages.app.chatConfig.variables.optional': '可选的',
  'pages.app.chatConfig.model.label': '模型',
  'pages.app.chatConfig.model.tooltip': '选择AI助手用于对话的模型',
  'pages.app.chatConfig.model.placeholder': '请选择模型',
  'pages.app.chatConfig.model.saveSuccess': '保存成功',
  'pages.app.chatConfig.tavily.label': 'Tavily API Key',
  'pages.app.chatConfig.tavily.tooltip': '用于互联网搜索增强的 API Key',
  'pages.app.chatConfig.tavily.placeholder': '请输入你的 Tavily API Key',
  'pages.app.chatConfig.tavily.howToGet': '如何获取？',
  'pages.app.chatConfig.temperature.label': '温度',
  'pages.app.chatConfig.temperature.tooltip': '控制回复的随机性',
  'pages.app.chatConfig.topP.label': 'Top P',
  'pages.app.chatConfig.topP.tooltip': '核采样阈值',
  'pages.app.chatConfig.presencePenalty.label': '存在惩罚',
  'pages.app.chatConfig.presencePenalty.tooltip': '控制回复中新话题的出现概率',
  'pages.app.chatConfig.frequencyPenalty.label': '频率惩罚',
  'pages.app.chatConfig.frequencyPenalty.tooltip': '控制回复中重复词汇的出现概率',
  'pages.app.chatConfig.maxTokens.label': '最大 Token 数',
  'pages.app.chatConfig.maxTokens.tooltip': '模型生成的最大回复长度',
  'pages.app.chatConfig.creativity.label': '自由度',
  'pages.app.chatConfig.creativity.precise': '精准',
  'pages.app.chatConfig.creativity.balanced': '平衡',
  'pages.app.chatConfig.creativity.creative': '创意',
};
